module.exports = __webpack_public_path__ + "static/media/google-play.7a3df84f.svg";